import Vue from 'vue'
import CA, { watch } from '@vue/composition-api'
Vue.use(CA)

import { reactive } from '@vue/composition-api'

export const state = reactive({
  title: ``,
  content: '',
  action1: null,
  action2: null,
  persistent: false,
  loading: false,

  model: false
})

/**
 * title
 * content
 * action1 (label, onClick)
 * action2 (label, onClick)
 * loading
 */
export default () => {
  const queue = []

  const set = payload => {
    Object.entries(payload)
      .forEach(([prop, value]) => {
        state[prop] = value
      })

    state.model = true
    const unwatch = watch(
      () => state.model,
      () => {
        if (!state.model) {
          unwatch()
          unqueue()
        }
      }
    )
  }

  const unqueue = () => {
    setTimeout(() => {
      if (queue[0]) {
        const { content } = queue.pop()
        set({ content })
      }
    }, 1000)
  }

  const methods = {
    set: ({ isImportant, ...payload }) => {
      if (state.model) {
        if (isImportant) {
          queue.unshift(payload)
        } else {
          queue.push(payload)
        }
      } else {
        set(payload)
      }
    },
    unset: () => {
      state.model = false
    }
  }

  return {
    state,
    ...methods
  }
}
